export default __webpack_public_path__ + "static/393-5ae1163f602cf60f461444cad87f34c3.gif";